import {
  STATUS_NEW,
  STATUS_ACCEPT,
  STATUS_REJECT,
  STATUS_CANCELED,
  STATUS_ASSIGNED,
  STATUS_COMPLETED
} from 'components/common/constants/reservationStatusConstants';
import includes from 'lodash/includes';

export default class ReservationStatusHelper {
  constructor(reservation) {
    this.reservation = reservation;
    this.reservationStatus = reservation.status;
    this.onlineAndPaidOnTwoFlights = reservation.online_with_two_flights &&
      !reservation.payment_to_driver;
    this.isFlight = !reservation.flight.is_removed;
  }

  canCustomerEdit() {
    return includes(
      [STATUS_ACCEPT],
      this.reservationStatus
    ) && this.isFlight;
  }

  canCustomerCancel() {
    return includes(
      [STATUS_NEW, STATUS_ACCEPT, STATUS_ASSIGNED],
      this.reservationStatus
    );
  }

  canShowEdit() {
    return includes(
      [STATUS_NEW, STATUS_ACCEPT, STATUS_ASSIGNED],
      this.reservationStatus
    );
  }

  disableCancel() {
    return !this.isFlight ||
      (this.onlineAndPaidOnTwoFlights && this.reservationStatus === STATUS_NEW);
  }
}
